import { render, staticRenderFns } from "./SignatureV1.vue?vue&type=template&id=67855a54&scoped=true&"
import script from "./SignatureV1.vue?vue&type=script&lang=js&"
export * from "./SignatureV1.vue?vue&type=script&lang=js&"
import style0 from "./SignatureV1.vue?vue&type=style&index=0&id=67855a54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67855a54",
  null
  
)

export default component.exports